import { useState, useEffect } from 'react';
import { Zap } from 'lucide-react';
import { fmtCurrency } from '../../lib/format.js';
import { SaleNumpad } from './sale-numpad.jsx';
import { SaleSheetShell, SellButton } from './sale-sheet-shell.jsx';

// Spontan-Verkauf: Verkauf außerhalb des Sortiments. Bezeichnung optional, Preis via NumPad.
export function SpontanSheet({ open, onOpenChange, onSale, dark }) {
  const [note, setNote] = useState('');
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    if (open) setNote('');
  }, [open]);

  if (!open) return null;

  return (
    <SaleSheetShell
      open={open}
      onClose={() => onOpenChange(false)}
      testId="spontan-sheet"
      title="Spontan-Verkauf"
      subtitle="Artikel, der nicht im Sortiment ist"
      leading={
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[var(--tint-troedel)]">
          <Zap className="h-5 w-5 text-[var(--accent-troedel)]" />
        </div>
      }
      footer={
        <>
          <SaleNumpad tone="sale" prefill={0} caption="Preis" onValueChange={setAmount} />
          <SellButton
            amountLabel={fmtCurrency(amount)}
            disabled={!(amount > 0)}
            onClick={() => { if (amount > 0) { onSale?.(amount, note); } }}
          />
        </>
      }
    >
      {/* Bezeichnung (optional) — scrollt nicht in den NumPad */}
      <input
        type="text"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Bezeichnung (optional)"
        enterKeyHint="done"
        className="mb-1 h-11 w-full rounded-[12px] bg-[var(--fill-tertiary)] px-4 text-[17px] outline-none placeholder:text-[var(--label-tertiary)]"
      />
    </SaleSheetShell>
  );
}
